export const NAME = 'powerOfAttorney';